import { ProductMenuModifierDto } from '../productMenuModifier.dto';

/**
 * Response for get product menu modifiers when re-opening table.
 */
export interface IProductForTableReopenDto {
  /** List of Product Menu Modifiers. */
  productMenuModifiers: ProductMenuModifierDto[];
  /** Indicates does order has Sale Unit. */
  hasSaleUnit: boolean;
  /** List of Sale Unit Id's when available.  */
  saleUnitIds?: number[];
}
